import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'workflowUFOT', pure: false })
export class WorkflowUpdateOperationTypePipe implements PipeTransform {

    transform(operationType: number = 0, defaultValue: string = 'Replaced'): any {
        switch(operationType){
            case 1:
                return 'Appended';
            case 2:
                return 'Removed';
        }

        return defaultValue;
    }

}
